module.exports = __webpack_public_path__ + "img/banner2.8d813b0c.jpg";